export { renderSplitButton_unstable as renderSplitButton } from '@fluentui/react-button';
